@if (display) {
  <div class="banner">
    <img alt="warning icon" src="../../../../assets/images/warning-icon.png" />
    <p>We recommend using Chrome v83.0.4103.61 and above or Edge v83.0.478.50 and above.</p>
    <img
      alt="close icon"
      (click)="close()"
      style="width: 18px; height: 18px; margin-left: 4px; margin-top: -2.5px; cursor: pointer"
      src="../../../../assets/images/close.svg"
    />
  </div>
}
